import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ThemeColors } from '../../web/components-v2/Theme/theme';

interface UseTagColorMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface TagColorParams {
	tagId: string;
	color: keyof ThemeColors['pill'];
	impersonationContext?: Api.IImpersonationContext;
}

export function useTagColorMutation({ onSuccess, onError }: UseTagColorMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ tagId, color, impersonationContext }: TagColorParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tag/${tagId}/color`,
					queryParams: {
						value: color,
					},
				}),
				'PUT'
			);
		},
		onSuccess,
		onError,
	});
}
